export const namespace = 'tradeBlotter'
